import '../../plugins/jquery-ui/jquery-ui';
import '../../plugins/jquery-ui/ui/i18n/datepicker-fr';
import '../../../asset/wad/js/inspinia';
import '../../../node_modules/multiselect/js/jquery.multi-select';
import '../../../node_modules/multiselect/js/jquery.quicksearch';
import '../../../node_modules/select2/dist/js/select2';
import '../../../node_modules/bootstrap/dist/js/bootstrap';
import '../../../node_modules/datatables.net/js/jquery.dataTables';
import '../../../node_modules/datatables.net-bs/js/dataTables.bootstrap';
import '../../../node_modules/metismenu/dist/metisMenu';
import '../../../node_modules/jquery-slimscroll/jquery.slimscroll';
import '../../../node_modules/toastr/build/toastr.min.js';
import '../../../node_modules/timepicker';
import '../../../node_modules/bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min.js';
import '../../../node_modules/fontawesome-iconpicker/dist/js/fontawesome-iconpicker.min.js';

// Tinymce
import '../../../node_modules/tinymce/tinymce';
import '../../../node_modules/tinymce/themes/modern/theme.min.js';
import '../../../node_modules/tinymce-i18n/langs/fr_FR';

// Tinymce plugins
import '../../../node_modules/tinymce/plugins/advlist';
import '../../../node_modules/tinymce/plugins/autolink';
import '../../../node_modules/tinymce/plugins/lists';
import '../../../node_modules/tinymce/plugins/link';
import '../../../node_modules/tinymce/plugins/image';
import '../../../node_modules/tinymce/plugins/charmap';
import '../../../node_modules/tinymce/plugins/print';
import '../../../node_modules/tinymce/plugins/preview';
import '../../../node_modules/tinymce/plugins/anchor';
import '../../../node_modules/tinymce/plugins/searchreplace';
import '../../../node_modules/tinymce/plugins/visualblocks';
import '../../../node_modules/tinymce/plugins/code';
import '../../../node_modules/tinymce/plugins/fullscreen';
import '../../../node_modules/tinymce/plugins/insertdatetime';
import '../../../node_modules/tinymce/plugins/media';
import '../../../node_modules/tinymce/plugins/table';
import '../../../node_modules/tinymce/plugins/contextmenu';
import '../../../node_modules/tinymce/plugins/paste';
import '../../../node_modules/tinymce/plugins/hr';
import '../../../node_modules/tinymce/plugins/textcolor';
import '../../../node_modules/tinymce/plugins/colorpicker';
import '../../../node_modules/tinymce/plugins/autoresize';

// Gallery
import toastr from '../../../node_modules/toastr/build/toastr.min.js';
import plupload from '../../../node_modules/plupload/js/plupload.full.min.js';

$(document).ready(function() {
	// Btn visible
	$('.table').on('click','.btn-visible',function(){
		let self = $(this);
		let url = self.data('url');
		$.ajax({
			url : url,
			success : function(title){ 
				self.toggleClass('btn-danger');
				self.children($('i')).toggleClass('fa-close');
				self.toggleClass('btn-success');
				self.children($('i')).toggleClass('fa-check');
				self.attr('title', title);
			}
		});
	});

	// Sortable
	let dataTagSortable = document.getElementById('data-sortable');
  if (dataTagSortable){
    let dataSortable = JSON.parse(dataTagSortable.innerHTML);
    // Return a helper with preserved width of cells
    let fixHelper = function(e, ui) {
      ui.children().each(function() {
        $(this).width($(this).width());
      });
      return ui;
    };

    $(".sortable tbody").sortable({
      handle : '.move', 
      cursor: "move",
      items : "tr",
      helper: fixHelper,
        update : function () { 
          let order = $(this).sortable('serialize'); 
          $.post(dataSortable.url, order);
        } 
    }); 
  }

	// Datatables
	$('.table-dataTables').dataTable( {
		"paging":   false,
		"ordering": true,
		"bInfo":	false,
		"bFilter":  true,
		"aoColumnDefs" : [{
			"bSortable" : false, "aTargets" : [ "sorting_disabled" ],
			"bSearchable" : false, "aTargets" : [ "searchable_disabled" ],
		}],
		"language": {
			"sProcessing":	 "Traitement en cours...",
			"sSearch":		 "Rechercher&nbsp;:&nbsp;",
			"sLengthMenu":	 "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":		   "Affichage de l'&eacute;lement _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
			"sInfoEmpty":	  "Affichage de l'&eacute;lement 0 &agrave; 0 sur 0 &eacute;l&eacute;ments",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":	"",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":	"Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":	 "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":	  "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":	   "Suivant",
				"sLast":	   "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}		
		}						   
	});
	
	$('.table-dataTables-order').dataTable( {
		"paging":   false,
		"ordering": true,
		"order":	[],
		"bInfo":	false,
		"bFilter":  true,
		"aoColumnDefs" : [{
			"bSortable" : false, "aTargets" : [ "sorting_disabled" ],
			"bSearchable" : false, "aTargets" : [ "searchable_disabled" ],
		}],
		"language": {
			"sProcessing":	 "Traitement en cours...",
			"sSearch":		 "Rechercher&nbsp;:&nbsp;",
			"sLengthMenu":	 "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":		   "Affichage de l'&eacute;lement _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
			"sInfoEmpty":	  "Affichage de l'&eacute;lement 0 &agrave; 0 sur 0 &eacute;l&eacute;ments",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":	"",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":	"Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":	 "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":	  "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":	   "Suivant",
				"sLast":	   "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}		
		}						   
	});
	
	// Datepicker
	$.datepicker.setDefaults($.datepicker.regional['fr']);
	$.datepicker.setDefaults({ dateFormat: 'yy-mm-dd' });
	$('.date').datepicker({
		changeMonth: true,
		changeYear: true,
		showButtonPanel: true,
	});
	
	// Tinymce
	let wadAdminTinymceConfig = [
		{
			selector: ".tinymce",
			plugins: [
				"advlist autolink lists link image charmap print preview anchor",
				"searchreplace visualblocks code fullscreen",
				"insertdatetime media table contextmenu paste hr"
			],
			toolbar: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
			paste_word_valid_elements: "b,strong,i,em,h1,h2,h3",
			language : "fr_FR",
			height : "350px",
			menubar: "edit insert view format table tools",
			table_default_attributes: {
				class: 'table table-bordered table-striped'
			},
			relative_urls : false,
			remove_script_host : false,
			style_formats_merge: true,
			formats: {
				alignleft: [
			          {
			            selector: 'figure.image',
			            collapsed: false,
			            classes: 'align-left',
			            ceFalseOverride: true,
			            preview: 'font-family font-size'
			          },
			          {
			            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
			            styles: { textAlign: 'left' },
			            inherit: false,
			            preview: false,
			            defaultBlock: 'div'
			          },
			          {
			            selector: 'img,table',
			            collapsed: false,
			            styles: { float: 'left',margin:'0 10px 10px 0'},
			            preview: 'font-family font-size'
			          }
			        ],
			        alignright: [
			            {
			              selector: 'figure.image',
			              collapsed: false,
			              classes: 'align-right',
			              ceFalseOverride: true,
			              preview: 'font-family font-size'
			            },
			            {
			              selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
			              styles: { textAlign: 'right' },
			              inherit: false,
			              preview: 'font-family font-size',
			              defaultBlock: 'div'
			            },
			            {
			              selector: 'img,table',
			              collapsed: false,
			              styles: { float: 'right',margin:'0 0 10px 10px' },
			              preview: 'font-family font-size'
			            }
			          ],
			 },
		},
		{
			selector: ".tinymce-light",
			plugins: [
				"advlist autolink lists link print preview anchor",
				"searchreplace visualblocks code fullscreen",
				"contextmenu paste"
			],
			toolbar: "insertfile undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | link",
			paste_word_valid_elements: "b,strong,i,em,h1,h2,h3",
			language : "fr_FR",
			height : "350px",
			menubar: "edit view tools",
			paste_as_text: true
		}
	];
	wadAdminTinymceConfig.forEach(function(tc){
		tinyMCE.init(tc);
	});
	
	// Ajax status
	$('.table').on('click','.ajaxStatus',function(){ 
		let bouton = $(this);
		$.ajax({	
			url : bouton.attr('data-url'),
			type : 'POST',
			dataType : 'json',
			success : function (data) {
				console.log(data);
				bouton.removeClass(data.removeClass);
				bouton.addClass(data.addClass);
				bouton.attr('title', data.title);
				bouton.children(":first").removeClass(data.removeFont);
				bouton.children(":first").addClass(data.addFont);
			}
		});
	});
	
	// Select2
	$('.select2').select2();
	
	// Multiselect
	$('.multiselect').multiSelect({
		selectableHeader: "<input type='text' class='form-control' autocomplete='off' placeholder='Recherche'>",
			selectionHeader: "<input type='text' class='form-control' autocomplete='off' placeholder='Recherche'>",
			afterInit: function(ms){
				let that = this,
						$selectableSearch = that.$selectableUl.prev(),
						$selectionSearch = that.$selectionUl.prev(),
						selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)',
						selectionSearchString = '#'+that.$container.attr('id')+' .ms-elem-selection.ms-selected';

				that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
				.on('keydown', function(e){
					if (e.which === 40){
						that.$selectableUl.focus();
						return false;
					}
			});

			that.qs2 = $selectionSearch.quicksearch(selectionSearchString)
			.on('keydown', function(e){
		if (e.which == 40){
			that.$selectionUl.focus();
			return false;
		}
			});
		},
		afterSelect: function(){
			this.qs1.cache();
			this.qs2.cache();
		},
		afterDeselect: function(){
			this.qs1.cache();
			this.qs2.cache();
		}
	});

	// Colorpicker
	$('.colorpicker').colorpicker({
		format:"hex",
		align:"left",
	});

	// Iconpicker
	if ($('.iconpicker').length > 0){
		$('.iconpicker').prop('disabled', true);
		$.ajax({
			url : 'json/config-icons.json',
			dataType : 'json',
			success : function(icons){
				$('.iconpicker').iconpicker({placement: 'bottomLeft',icons : icons});
				$('.iconpicker').prop('disabled', false);
			},
			error : function(e){
				console.log(e);
			}
		});
	}
    
	// Timepicker
	$('.timepicker').timepicker({
		'show2400' : true,
		'timeFormat':'H:i' 
	});
    
	// Keep alive (server status)
	$('#status-title').tooltip({title: 'Connexion au serveur indéterminée',placement:'bottom'});
	keepAlive();
	let status = setInterval(keepAlive, 300000);
	
	function keepAlive() {
		let dataTag = document.getElementById('data');
		if (dataTag){
			let data = JSON.parse(dataTag.innerHTML);
			$.ajax({
				url: data.keepAliveUrl,
				type: 'get',
				dataType: 'json',
				cache: 'false',
				timeout: 10000,
				success: function(data) {
					statusUpdate(true);
				},
				error: function(jqXHR, textStatus, error) {
					statusUpdate(false);
				},
			});
		}
	}
	
	function statusUpdate(status) {
		if(status) {
			$('#status-color').addClass("text-info");
			$('#status-color').removeClass("text-danger text-success");
			$('#status-title').data('bs.tooltip').options.title='Connexion au serveur réussie';
		} else {
			$('#status-color').removeClass("text-info");
			$('#status-color').addClass("text-danger text-success");
			$('#status-title').data('bs.tooltip').options.title='Connexion au serveur perdue';
		}
	}

	// Gallery
	let dataGalleryTag = document.getElementById('data-gallery');
  const dataGallery = JSON.parse(dataGalleryTag ? dataGalleryTag.innerHTML : null);

  // Toastr
  toastr.options = {
    "closeButton": true,
    "debug": false,
    "progressBar": false,
    "preventDuplicates": false,
    "positionClass": "toast-top-right",
    "onclick": null,
    "showDuration": "400",
    "hideDuration": "1000",
    "timeOut": "70000",
    "extendedTimeOut": "10000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
  }

	console.log(dataGallery);
  if (dataGallery){
    // Sortable
    $(".gallery-sortable").sortable({
      handle : '.handle',
      update : function () {
        let order = $('.gallery-sortable').sortable('serialize');
        $.post(dataGallery.sortableUrl, order);
      }
    
    });

    // Description
    if(dataGallery.caption){
      let oldDescription = '';
      $(document).on('click','.textarea-blur',function(){
        let self = $(this);
        if (self[0] && self[0].value){
          oldDescription = self[0].value;
        }
      });
      $(document).on('blur','.textarea-blur',function(){
        let self = $(this);
        let url = dataGallery.editUrl;
        if (self[0] && self[0].value && oldDescription != self[0].value){
          $.ajax({
            url : url,
            data : {
              description : self[0].value,
              idGalleryImage : self.data('id')
            },
            success : function(res){
              toastr.info('Description changée');
            }
          });
        }
      });
    }

    // Upload
    let uploader = new plupload.Uploader({
      runtimes : 'gears,html5,flash,silverlight',
      browse_button : 'pickfiles',
      container: 'formImages',
      file_data_name : 'image',
      multipart: true,
      url : dataGallery.uploadUrl,
      /*
      flash_swf_url : '<?php echo $this->basePath();?>/asset/admin/js/plupload/Moxie.swf',
      silverlight_xap_url : '<?php echo $this->basePath();?>/asset/admin/js/plupload/Moxie.xap',
      */
      filters : {
        max_file_size : '20mb',
        mime_types: [
          {title : "Image files", extensions : "jpeg,jpg,gif,png"}
        ]
      },
    
      init: {
        FilesAdded: function(up, files) {
          plupload.each(files, function(file) {
            toastr.info('<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ') <b></b></div>');
          });
          uploader.start();
        },
        UploadProgress: function(up, file) {
          document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
        },
        Error: function(up, err) {
          toastr.error("Error #" + err.code + ": " + err.message + " (" + err.file.name +")");
          document.getElementById('console').innerHTML += "\nError #" + err.code + ": " + err.message + " (" + err.file.name +")<br />";
        },
        FileUploaded: function(up, file, response) {
          let dataGalleryFile = $.parseJSON(response.response);
          $('#' + file.id + " b").html("100%");
          
          $('#formImages div.images').append(dataGalleryFile.image.html).fadeIn();
          
          $('#'+file.id).parent().parent().fadeOut("slow");
        },
        
      },
    
      headers : {'X-Requested-With' : 'XMLHttpRequest'}
    });
    
    uploader.init();

    // Delete
    $("#formImages").submit(function() {
      let form = $(this);
      let url = dataGallery.deleteUrl;
      let conf = confirm('Êtes vous sûr de vouloir supprimer la sélection ?');
      if(!conf)
      {
        return false;
      }

      $.ajax({
        url: url,
        type: $(this).attr('method'),
        data: $(this).serialize(),
        dataType: 'json',
        success: function(json) {
          if(json.response.statut == true) {
            $('#'+form.attr('id')+" input[type=checkbox]:checked").each(function() {
              $(this).parent('label').parent('div').remove();
            });
          } else {
            alert('Erreur : '+ json.response);
          }
        }
      });
      return false;
    });
  }
});
